import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/app.css';
import './shared/i18n';
import { App } from './app/App';
import { applyLegacyHashRedirect } from './app/legacyHashRedirect';

// Bookmarks from the retired hash-routed SPA become real paths before the router reads the URL.
applyLegacyHashRedirect();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
